import { TokenManager } from '../lib/auth/token-manager';

/**
 * Hook minimal pour exposer la classe statique TokenManager.
 * Usage : const tokenManager = useTokenManager();
 * Toutes les méthodes sont statiques, donc tokenManager === TokenManager.
 */
export default function useTokenManager() {
  return TokenManager;
}
